import Status from './Status.styled';

export default Status;
